interface SectionTitleProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionTitle({ kicker, title, desc, align = 'left' }: SectionTitleProps) {
  return (
    <div className={`${align === 'center' ? 'text-center' : ''}`}>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800 ${
          align === 'center' ? '' : ''
        }`}
      >
        <i className="ri-sparkling-2-line"></i>
        {kicker}
      </span>
      <h2 className="mt-3 text-2xl text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className={`mt-3 text-sm leading-relaxed text-foreground-600 md:text-base ${align === 'center' ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`}>{desc}</p>}
    </div>
  );
}